module.exports = __webpack_public_path__ + "img/gas_header.18677c22.jpg";